<template>
  <AuthContainer>
    <div class="p-10 login-tabs-container">
      <div class="vx-card__title mb-4">
        <h3 class="mb-3 mt-2">Reset your password</h3>
        <p v-show="!message" class="mt-2 mb-2">Please enter your email address. We will send you an email to reset your password. Got a login already? <router-link to="/login">Login here</router-link>
        </p>
      </div>

      <form v-show="!message">
        <div class="vx-row">
          <div class="vx-col w-full mb-3">
            <vs-input
              name="email"
              icon-no-border
              icon="icon icon-user"
              icon-pack="feather"
              label-placeholder="Email"
              v-model="form.email"
              class="w-full"
              v-validate="'required|email'" />
            <p class="text-xs text-danger mt-1" v-if="errors.has('email')">{{ errors.first('email') }}</p>
          </div>
        </div>

        <vs-button
          class="mt-3"
          @click="sendEmail"
        >Send Email</vs-button>

      </form>
      
      <vs-alert
        color="success"
        :active="message ? true : false"
        class="mt-1"
      >{{ message }}</vs-alert>
      <p v-if="message" class="text-center mt-6 mb-1">Want Contactless Visitor Management for your business? <router-link to="signup">Sign up here</router-link></p>

    </div>
  </AuthContainer>
</template>

<script>
import auth0 from '@/auth0';
import AuthContainer from '@/views/pages/components/AuthContainer.ts.vue';
export default {
  components: {
    AuthContainer
  },
  data: () => ({
    message: undefined,
    form: {
      email: ''
    }
  }),
  methods: {
    async sendEmail () {
      const me = this;
      return await this.$validator.validateAll().then(valid => {
        if (valid) {
          auth0.changePassword(this.form.email).then(message => {
            me.message = message
          });
        }
      });
    }
  }
};
</script>
